import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import StatsCard from "../cards/StatsCard";
import State from "../State";
import Modal from "./Modal";

const FailedLearningPathExamModal = ({
  id,
  isOpened,
  totalQuestions,
  correctCount,
  incorrectCount,
  percentage,
  attempts,
  nextAttemptTime,
  learningPathId,
}) => {
  const { t } = useTranslation(["learningPaths"]);
  const [showModal, setShowModal] = useState(isOpened);
  const [countdown, setCountdown] = useState("");

  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const bootstrapModal = window.bootstrap?.Modal?.getOrCreateInstance(el);
    if (!bootstrapModal) return;
    if (isOpened) {
      bootstrapModal.show();
    } else {
      bootstrapModal.hide();
    }
  }, [isOpened, id]);

  useEffect(() => {
    setShowModal(isOpened);
  }, [isOpened]);

  // Countdown timer effect
  useEffect(() => {
    if (!nextAttemptTime) {
      setCountdown("");
      return;
    }

    const updateCountdown = () => {
      const now = new Date();
      const target = new Date(nextAttemptTime);
      const diff = target - now;

      if (diff <= 0) {
        setCountdown("");
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setCountdown(
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`,
      );
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [nextAttemptTime]);

  const handleBackToDetails = () => {
    setShowModal(false);
    window.location.href = `/employee/learning_paths/${learningPathId}`;
  };

  const computedPercentage =
    totalQuestions > 0
      ? parseInt(((correctCount ?? 0) / totalQuestions) * 100)
      : 0;
  const displayPercentage =
    percentage != null && !Number.isNaN(Number(percentage))
      ? Number(percentage)
      : computedPercentage;

  return (
    <Modal id={id} maxWidth="600" isOpened={showModal} hasCloseBtn={false}>
      <State
        titleFontSize={24}
        descFontSize={14}
        className="failed-path-exam"
        id="fail-path-exam"
        hasIconStroke
        type="fail"
        title={t("pathExamFailedTitle")}
        desc={t("pathExamFailedDesc")}
      >
        <div className="row state__details">
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="درجتك"
              num={`${displayPercentage}%`}
              state="default"
              titleFontColor="font-color-grey"
            />
          </div>
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="الإجابات الصحيحة"
              num={correctCount ?? 0}
              state="success"
            />
          </div>
          <div className="col-sm-4 mb-3 mb-sm-0">
            <StatsCard
              title="الإجابات الخاطئة"
              num={incorrectCount ?? 0}
              state="fail"
            />
          </div>
        </div>
        {attempts !== undefined && attempts < 2 && (
          <div className="mt-3">
            <p className="font_14 font-color-grey mb-2">
              {t("pathExamAttemptsCount", { count: attempts })}
            </p>
            {nextAttemptTime && (
              <p className="font_14 font-color-grey mb-0">
                {countdown
                  ? t("pathExamNextAttemptTime", {
                      datetime: countdown,
                    })
                  : t("pathExamNextAttemptTime", {
                      datetime: moment(nextAttemptTime).format(
                        "DD/MM/YYYY HH:mm",
                      ),
                    })}
              </p>
            )}
          </div>
        )}
        <div className="d-grid gap-2 state__actions">
          <button
            type="button"
            className="btn btn-main-color"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleBackToDetails}
          >
            {t("pathExamBackToDetails")}
          </button>
        </div>
      </State>
    </Modal>
  );
};

export default FailedLearningPathExamModal;
